/**
 * Returns a toLocaleString() of the value passed in
 * @param  {string} value - the value you want to convert
 * @param  {object} [opts={ minimumFractionDigits = 0 }] - the optional object
 * See - https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
 */
export default function currency(num, opts) {
  let numParm = num;
  let result;
  if (!num || Number.isNaN(num) || num === '') {
    numParm = 0;
  }
  const hasDollarSign = numParm.toString().match(/^\$/);
  const tryParse = parseFloat(numParm, 10);
  if (Number.isNaN(tryParse)) {
    return numParm;
  }
  result = tryParse;

  const myOpts = {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    ...opts,
  };
  if (myOpts.minimumFractionDigits > 0 && myOpts.maximumFractionDigits === 0) {
    myOpts.maximumFractionDigits = myOpts.minimumFractionDigits;
  }

  // NOTE: currently only formatting as US currency
  result = result.toLocaleString(
    'en-US',
    myOpts,
  );

  const isNegativeNum = (result < 0);

  if (hasDollarSign) {
    result = result.toString().replace(/^/, '$');
  }

  if (isNegativeNum && hasDollarSign) {
    result = result.replace(/^/, '-$');
  }

  if (isNegativeNum) {
    result = result.replace(/-/, '-$');
  }

  if (!isNegativeNum && hasDollarSign) {
    result = result.replace(/^/, '$');
  }

  if (result.match(/^\$\$/)) {
    result = result.replace(/^\$\$/, '');
  }

  return result;
}
